import Map from "can/map/";
import Refresh from "src/components/shared/refresh";
import Help from "src/help-pages/";
import Account from "src/components/shared/switch-account";


const HeaderViewModel = Map.extend({
    init: function () {
        "use strict";

        this.helpManager = new Help();
        this.account = new Account();
        Vistracks.Scope.Refresh = Refresh;

        this.refreshData();

        // If this is an InTouch GPS user, hide the sign-out button.
        if (Cookies.get("vt-intouch") !== undefined || Cookies.get("ssoUser") !== undefined) {
            Vistracks.Scope.AppState.attr("hideLogout", true);
        }
    },
    data: {
        accountName: "",
        userName: "",
        canSwitchAccounts: false,
        isSwitchAppButtonVisible: false,
        isClassicFleetVisible: false,
        isFleetVersionTwoVisible: false,
    },
    webV2Url: "",
    classicUrl: "",

    signout: function (event) {
        "use strict";
        event.stopImmediatePropagation();

        BootstrapDialog.show({
            title: "",
            type: "type-warning",
            size: "size-small",
            closeByBackdrop: false,
            message: "<div class='loader' style='text-align:center' ><div class='preloader'><div class='spinner-layer pl-red'><div class='circle-clipper left'><div class='circle'></div></div><div class='circle-clipper right'><div class='circle'></div></div></div></div><p><strong>" + Locale.translate("Logging out") + ".. " + Locale.translate("Please wait") + "</strong></p></div>",

            onshown: function () {
                Refresh.clear();
                Refresh.unbind("interval.value");

                // Remove the scroll event attached to the window's event listener
                Vistracks.HelperUtils.viewportCaching.remove();

                Cookies.remove("JSESSIONID", {
                    path: "/",
                });

                Cookies.remove("RefreshRate", {
                    path: "/",
                    secure: true,
                    sameSite: "None"
                });

                Cookies.remove("credentials", {
                    path: "/",
                    secure: true,
                    sameSite: "None"
                });

                Cookies.remove("VT-On-Behalf-Of", {
                    path: "/",
                    secure: true,
                    sameSite: "None"
                });

                Cookies.remove("userRoles", {
                    path: "/",
                    secure: true,
                    sameSite: "None"
                });

                Cookies.remove("isTopLevelAccount", {
                    path: "/",
                    secure: true,
                    sameSite: "None"
                });

                Cookies.remove("isPrimaryAccountReseller", {
                    path: "/",
                    secure: true,
                    sameSite: "None"
                });

                Cookies.remove("canConfigureVBUSDeviceTab", {
                    path: "/",
                    secure: true,
                    sameSite: "None"
                });

                Cookies.remove("viewport", {
                    path: "/",
                    secure: true,
                    sameSite: "None"
                });

                Cookies.remove("driversTZ", {
                    path: "/",
                    secure: true,
                    sameSite: "None"
                });

                Cookies.remove("routes", {
                    path: "/",
                    secure: true,
                    sameSite: "None"
                });

                Cookies.remove("refreshRateInterval", {
                    path: "/",
                    secure: true,
                    sameSite: "None"
                });

                sessionStorage.removeItem('authToken');
                location.replace("j_spring_cas_security_logout");
            }
        });
    },

    help: function (event) {
        "use strict";
        event.stopImmediatePropagation();

        this.helpManager.create({
            helpDir: Vistracks.Scope.AppState.page,
            helpComponent: Vistracks.Scope.AppState.slug
        });
    },

    refresh: function (event) {
        "use strict";
        event.stopImmediatePropagation();
        Refresh.refreshData();
    },

    refreshData: function () {
        "use strict";
        const canSwitchAccounts =
            Vistracks.Scope.AppState.attr("canViewSubAccounts") ||
            Vistracks.Scope.AppState.attr("isUserRoleAssetAdmin");

        this.attr("data.accountName", Vistracks.Scope.AppState.attr("account"));
        this.attr("data.userName", Vistracks.Scope.AppState.attr("user"));
        this.attr("data.canSwitchAccounts", canSwitchAccounts);

        Vistracks.Scope.AppState.bind("account", () => {
            this.attr("data.accountName", Vistracks.Scope.AppState.attr("account"));
            this.attr("data.userName", Vistracks.Scope.AppState.attr("user"));
            this.attr("data.canSwitchAccounts", canSwitchAccounts);
        });
    },

    switchAccount: function (event) {
        "use strict";
        event.stopImmediatePropagation();

        BootstrapDialog.closeAll();
        this.account.create({});
    }
});

export default HeaderViewModel;
